var elements = $(".countdown_timer");

$(elements).each(function (el) {
  var element = $(elements[el]);
  var date = element.attr("data-timer-date");
  var day = date.slice(0, 2);
  var month = date.slice(3, 5);
  var year = date.slice(6, 10);
  var time = date.slice(11, 13)
  var minute = date.slice(14, 16);
  
  console.log(year, month - 1, day, time, minute)

  var countDownDate = new Date(year, month - 1, day, time, minute);

  countdown(countDownDate).then(result => {
    element.text(result.days + ":" + result.hours + ":" + result.minutes + ":" + result.seconds);
    element.parent().removeClass("hidden");
    console.log(element)
  })
  .catch(() => {
    clearInterval(x);
    $(".hero_heading_timer_text").toggle();
    $(".hero_heading_default_text").toggle("hidden");
    $(".hero_heading_default_text").removeAttr("hidden")
    $(".hero_link").removeAttr("disabled");
  });
  
  var x = setInterval(function () {
    countdown(countDownDate).then(result => {
      element.text(result.days + ":" + result.hours + ":" + result.minutes + ":" + result.seconds);
    })
    .catch(() => {
      clearInterval(x);
      $(".hero_heading_timer_text").addClass("hidden");
      $(".hero_heading_default_text").removeClass("hidden");
      $(".hero_heading_default_text").removeAttr("hidden")
      $(".hero_link").removeAttr("disabled");
    });
  }, 1000);
});

function countdown(countDownDate) {
  return new Promise(function (resolve, reject) {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    days = days < 10 ? "0" + days : days;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    if (distance > 0) {
      resolve({ days: days, hours: hours, minutes: minutes, seconds: seconds})
    } else {
      reject()
    }
  })
}